import React, { FC } from 'react';
import EmptyHeart from '@zola/zola-ui/src/assets/images/favorites/heart-empty-dark-outline.svg';
import { useFavoriteToggleStyles } from './useFavoriteToggleStyles';

const DISPLAY_BLOCK = { display: 'block' };

type FavoriteSuiteTogglePlaceholderProps = {
  className?: string;
  height?: number;
};

export const FavoriteSuiteTogglePlaceholder: FC<FavoriteSuiteTogglePlaceholderProps> = ({
  className,
  height = 24,
}) => {
  const { iconHeight, toggleStyle } = useFavoriteToggleStyles(height);

  return (
    <div className={className}>
      <div style={toggleStyle}>
        <img src={EmptyHeart} height={iconHeight} style={DISPLAY_BLOCK} alt="" />
      </div>
    </div>
  );
};

export default FavoriteSuiteTogglePlaceholder;
